import React, { useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, ErrorToString, RequestStatus } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const PrinterLabelPreview: React.FunctionComponent<{
    zpl: string;
    dpmm: string;
    width: string;
    height: string;
    index: string;
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const fetchPreview = api.hooks.printerLabel.generateZPLPreview();

    const [cancel, setCancel] = useState<NodeJS.Timeout | null>(null);

    const [image, setImage] = useState("");

    useEffect(() => {
        if (cancel != null) {
            clearTimeout(cancel);
        }

        setCancel(setTimeout(() => {
            if ((props.zpl || "").length == 0) {
                setImage("");
                return;
            }
            fetchPreview.send(session.current.context, props, (img) => {
                if (img == null) {
                    setImage("");
                } else {
                    setImage(img);
                }
            });
        }, 500));

    }, [props.zpl, props.width, props.height, props.dpmm, props.index]);

    if (fetchPreview.err != null) {
        return <div style={{ padding: 20, color: "red", textAlign: "center" }}>{ErrorToString(fetchPreview.err)}</div>;
    }

    return <div style={{ position: "relative" }}>

        {image.length > 0 && (
            <img src={image} style={{
                width: "100%",
                opacity: fetchPreview.status == RequestStatus.loading ? 0.4 : 1
            }}></img>
        )}


        {(fetchPreview.status == RequestStatus.loading) && (
            <div style={{
                textAlign: "center",
                borderRadius: 10,
                border: "solid 2px lightgray",
                position: "absolute",
                left: "0%",
                right: "0%",
                top: 100,
                marginLeft: "auto",
                marginRight: "auto",
                width: 200,
                backgroundColor: "white"
            }}>
                <div style={{ padding: 20 }}>
                    <div style={{ marginBottom: 20 }}>{t("labels.generatingPrev")}</div>
                    <CircularProgress size={30}></CircularProgress>
                </div>
            </div>
        )}
    </div>
}
PrinterLabelPreview.propTypes = {
    zpl: propTypes.string.isRequired,
    dpmm: propTypes.string.isRequired,
    width: propTypes.string.isRequired,
    height: propTypes.string.isRequired,
    index: propTypes.string.isRequired
}
export default PrinterLabelPreview;